/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/display-name */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { formLabel } from '@assets/styles/formStyles';
import { StyleSheet, View } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import PropTypes from 'prop-types';

const propTypes = {
  label: PropTypes.string,
  secondLabel: PropTypes.node,
  hideLabel: PropTypes.bool,
  isRequired: PropTypes.bool,
};

const defaultProps = {
  label: '',
  secondLabel: false,
  hideLabel: false,
  isRequired: false,
};

const FormLabel = (props) => {
  const { label, secondLabel, hideLabel, isRequired } = props;

  return (
    <>
      {label && !hideLabel ? (
        <View style={styles.mainLabel}>
          {isRequired ? (
            <SociollaText style={[formLabel, styles.label]}>
              {label ? label : ''}
              <SociollaText style={styles.required}>*</SociollaText>
            </SociollaText>
          ) : (
            <SociollaText style={formLabel}>{label ? label : ''}</SociollaText>
          )}
          {secondLabel ? secondLabel : false}
        </View>
      ) : (
        false
      )}
    </>
  );
};

const styles = StyleSheet.create({
  mainLabel: { flexDirection: 'row' },
  label: {
    color: Colors.grey14,
    lineHeight: 18,
    paddingRight: 5,
  },
  required: {
    fontSize: 16,
    color: Colors.blue0,
  },
});

FormLabel.propTypes = propTypes;
FormLabel.defaultProps = defaultProps;

export default React.memo(FormLabel, (prev, next) => prev == next);
